// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"a104c9291ec2de1172c7","655":"1f36e60cfa3727ada59f"}[chunkId] + ".js";
};